export default {

  'clientInfo.add': '新增banner',
  'clientInfo.bannerTitle': '标题',
  'clientInfo.enterBannerTitle': '请输入标题',
  'clientInfo.bannerTitleMaxLength': '标题长度不能超过50个字符',
  'clientInfo.allUsers': '全部用户',
  'clientInfo.client': '客户端',
  'clientInfo.langName': '语言',
  'clientInfo.forwardCode': '跳转Code',
  'clientInfo.indexSpopupType': '首页弹窗类型',
  'clientInfo.currency': '币种',
  'clientInfo.selectCurrency': '请选择币种',
  'clientInfo.imageType': '展示位置',
  'clientInfo.selectImageType': '请选择展示位置',
  'clientInfo.displayTarget': '可见用户群体',
  'clientInfo.selectDisplayTarget': '请选择可见用户群体',
  'clientInfo.allUsersOneClick': '全部用户',
  'clientInfo.advancedSettings': '高级设置（可选）',
  'clientInfo.liveStreamTag': '直播流',
  'clientInfo.unloggedUser': '未登录用户（访客）',
  'clientInfo.noDepositUser': '未存款用户',
  'clientInfo.noDepositUserTip': '未存款用户仅针对已登录且未完成首存的玩家，不可与 VIP 等级或未登录用户同时选择',
  'clientInfo.vipLevelGroup': 'VIP 等级',
  'clientInfo.liveUrl': '直播流地址',
  'clientInfo.enterLiveUrl': '请输入直播流地址',
  'clientInfo.liveUrlMaxLength': '直播流地址长度不能超过500个字符',
  'clientInfo.liveColumn': '直播',
  'clientInfo.selectLiveFilter': '请选择',
  'clientInfo.hasLiveUrl': '有直播流',
  'clientInfo.noLiveUrl': '无直播流',
  'clientInfo.indexBannerImage': '首页banner图',
  'clientInfo.discountBannerImage': '优惠banner图',
  'clientInfo.thirdPartyLoginAd': '首次三方登录页广告',
  'clientInfo.kioskBannerImage': '台式机banner图',
  'clientInfo.checkinActivityBannerImage': '签到与活跃活动banner图',
  'clientInfo.treasureBoxActivityBannerImage': '宝箱活动banner图',
  'clientInfo.loginBannerImage': '登录页banner图',
  'clientInfo.registerBannerImage': '注册页banner图',
  'clientInfo.startupBannerImage': '启动页banner图',
  'clientInfo.language': '语言',
  'clientInfo.selectLanguage': '请选择语言',
  'clientInfo.enterMenuOrder': '请输入菜单排序',
  'clientInfo.enterMenuLink': '请输入菜单链接',
  'clientInfo.redirectLink': '跳转链接/code',
  'clientInfo.enterRedirectLink': '请输入跳转链接/code',
  'clientInfo.uploadImage': '请上传图片',
  'clientInfo.pc': 'PC',
  'clientInfo.h5': 'H5',
  'clientInfo.app': 'APP',
  'clientInfo.kiosk': '台式机',
  'clientInfo.topImage': '顶部图片',
  'clientInfo.discountEntranceImage': '优惠入口图片',
  'clientInfo.logoImage': 'logo图片',
  'clientInfo.pendantImage': '挂件图片',
  'clientInfo.imageName': '图片名称',
  'clientInfo.enterImageName': '请输入图片名称',
  'clientInfo.popupType': '首页弹窗类型',
  'clientInfo.selectPopupType': '请选择弹窗类型',
  'clientInfo.loginBefore': '登录前',
  'clientInfo.loginAfter': '登录后',
  'clientInfo.registerSuccess': '注册成功',
  'clientInfo.registerNoDeposit': '注册未存款',
  'clientInfo.firstDepositSubmit': '首存提交',
  'clientInfo.firstDepositSuccess': '首存成功',
  'clientInfo.firstDepositDetainment': '首存挽留',
  'clientInfo.activityType': '活动入口类型',
  'clientInfo.selectActivityType': '请选择活动入口类型',
  'clientInfo.addSuccess': '新增成功',
  'clientInfo.addFailed': '新增失败',
  'clientInfo.editSuccess': '编辑成功',
  'clientInfo.editFailed': '编辑失败',
  'clientInfo.missingRedirectLink': '未填入跳转链接/code',
  'clientInfo.pcImageUpload': 'PC图片上传',
  'clientInfo.h5ImageUpload': 'H5图片上传',
  'clientInfo.appImageUpload': 'APP图片上传',
  'clientInfo.kioskImageUpload': '台式机图片上传',
  'clientInfo.formValidationFailed': '表单校验失败',
  'clientInfo.pcImage': 'PC图片',
  'clientInfo.h5Image': 'H5图片',
  'clientInfo.appImage': 'APP图片',
  'clientInfo.kioskImage': '台式机图片',
  'clientInfo.noImage': '暂无图片',
  'clientInfo.dataLoadFailed': '数据加载失败',
  'clientInfo.activityHomeImage': '活动首页',
  'clientInfo.contactMethod': '联系方式',
  'clientInfo.enterContactMethod': '请输入联系方式',
  'clientInfo.enterSort': '请输入排序',
  'clientInfo.redirectLinkCode': '跳转链接/code',
  'clientInfo.enterRedirectLinkCode': '请输入跳转链接/code',
  'clientInfo.iconUpload': '图标上传',
  'clientInfo.refreshMenuCache': '刷新菜单缓存',
  'clientInfo.menuName': '菜单名称',
  'clientInfo.enterMenuName': '请输入菜单名称',
  'clientInfo.menuIcon': '菜单图标',
  'clientInfo.navName': '导航名称',
  'clientInfo.enterNavName': '请输入导航名称',
  'indexLtMenu.menuIcon': '菜单图标',
  'indexBotMenu.menuName': '菜单名称',
  'indexBotMenu.enterMenuName': '请输入导航名称',
  'indexBotMenu.menuIcon': '菜单图标',
  'indexBotMenu.menuOrder': '菜单排序',
  'indexBotMenu.menuLink': '菜单链接',
  'indexBotMenu.h5Icon': 'H5图标',
  'indexBotMenu.pcIcon': 'PC图标',
  'indexBotMenu.isEnable': '是否启用',
  'indexBotMenu.isMain': '是否主菜单',
  'clientInfo.imageTitle': '图片标题',
  'clientInfo.enterImageTitle': '请输入图片标题',
  'clientInfo.status': '状态',
  'clientInfo.selectStatus': '请选择状态'
}
